import React from 'react'
import { css, keyframes } from 'emotion'
import moment from 'moment'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import noteStatuses from 'config/constants/noteStatuses'

const pulsingAnimation = keyframes`
   0% { opacity: 0.2; }
   50% { opacity: 1; }
   100% { opacity: 0.2; }
`

const NoteStatusBlock = ({
   dateLastUpdated,
   lastUpdatedByAuthor,
   lockedBy,
   lockedByCurrentConnection,
   noteStatus,
   textColor,
   textSize
}) => (
   <>
      {noteStatus === noteStatuses.NOTE_STATUS_LOCKED && (
         <View
            float="left"
            display="flex"
            alignItems="center"
            padding="0px 15px 0px 0px">
            <View
               className={css`animation: ${pulsingAnimation} 2000ms infinite linear;`}
               width="9px"
               height="9px"
               borderRadius="50%"
               backgroundColor="rgba(74, 223, 160, 0.9)"
               marginRight="9px"
            />
            {!lockedByCurrentConnection && (
               <Text
                  size={textSize}
                  color="rgba(43, 180, 122, 0.9)"
                  transform="uppercase">
                  {`Currently being edited by ${lockedBy}`}
               </Text>
            )}
         </View>
      )}
      {noteStatus === noteStatuses.NOTE_STATUS_EDITING && (
         <View
            display="flex"
            alignItems="center"
            padding="0px 15px 0px 0px">
            <View
               className={css`animation: ${pulsingAnimation} 2000ms infinite linear;`}
               width="9px"
               height="9px"
               borderRadius="50%"
               backgroundColor="#ccc"
               marginRight="9px"
            />
            <Text size={textSize} color={textColor} transform="uppercase">
               Syncing
            </Text>
         </View>
      )}
      {noteStatus === noteStatuses.NOTE_STATUS_READY && (
         <Text color={textColor} size={textSize} transform="uppercase">
            {`Last updated by ${lastUpdatedByAuthor} ${moment(dateLastUpdated).fromNow()}`}
         </Text>
      )}
   </>
)

NoteStatusBlock.propTypes = {
   dateLastUpdated: PropTypes.string.isRequired,
   lastUpdatedByAuthor: PropTypes.string.isRequired,
   lockedBy: PropTypes.string,
   lockedByCurrentConnection: PropTypes.bool.isRequired,
   noteStatus: PropTypes.number.isRequired,
   textColor: PropTypes.string,
   textSize: PropTypes.string
}

NoteStatusBlock.defaultProps = {
   lockedBy: undefined,
   textColor: '#aaa',
   textSize: '0.8'
}

export default NoteStatusBlock
